import React, { useState, useEffect } from "react";

const ReliableAuthorities = () => {
  const [context1, setContext1] = useState("");
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("");
  const [data, setData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  // Fetch data from API on component mount
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch("https://admindashboard.clns.in/api/dashboard/reliable-authorities/");
      const result = await response.json();
      if (result.status) {
        setData(result.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
    setFileName(e.target.files[0]?.name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("context1", context1);
    formData.append("image", image);

    try {
      const response = await fetch("https://admindashboard.clns.in/api/dashboard/reliable-authorities/", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (result.status) {
        fetchData(); // Fetch updated data after submission
        setContext1(""); // Reset form
        setImage(null);
        setFileName("");
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const handleDelete = async (id) => {
    setIsDeleting(true);
    try {
      // Get token from localStorage
      const token = localStorage.getItem('token');
      console.log(token);
      
      
      if (!token) {
        console.error("Authentication token not found");
        setIsDeleting(false);
        return;
      }
      
      // Using the same API endpoint with DELETE method and appending the ID
      const response = await fetch(`https://admindashboard.clns.in/api/dashboard/reliable-authorities/${id}/delete/`, {
        method: "DELETE",
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      // Check the response status
      if (response.ok) {
        // Remove the item from local state to update UI immediately
        setData(data.filter(item => item.id !== id));
      } else {
        const errorData = await response.json();
        console.error("Error deleting data:", errorData);
      }
      
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <style>
        {`
          .container {
            max-width: 900px;
            margin: 0 auto;
            padding: 30px;
            font-family: Arial, sans-serif;
          }
          .form-container {
            background-color: #f9f9f9;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
            margin-bottom: 30px;
          }
          .input-group {
            margin-bottom: 20px;
          }
          .input-group label {
            font-size: 16px;
            font-weight: bold;
            color: #333;
          }
          .input-group input {
            padding: 10px;
            font-size: 14px;
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 100%;
            margin-top: 5px;
          }
          .file-name {
            margin-top: 5px;
            font-size: 14px;
            color: #555;
          }
          .submit-btn {
            padding: 10px 20px;
            font-size: 16px;
            background-color: #28a745;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            width: 100%;
          }
          .submit-btn:hover {
            background-color: #218838;
          }
          .data-table {
            margin-top: 30px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          }
          th, td {
            padding: 12px;
            text-align: left;
            border: 1px solid #ddd;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          tr:hover {
            background-color: #f1f1f1;
          }
          .image-thumbnail {
            width: 100px;
            height: 100px;
            object-fit: cover;
            border-radius: 4px;
          }
          .delete-btn {
            padding: 6px 12px;
            background-color: #dc3545;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.2s;
          }
          .delete-btn:hover {
            background-color: #c82333;
          }
          .delete-btn:disabled {
            background-color: #e4717a;
            cursor: not-allowed;
          }
          .actions-column {
            text-align: center;
          }
        `}
      </style>

      <div className="container">
        <div className="form-container">
          <h2>Reliable Authorities Form</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Context 1:</label>
              <input
                type="text"
                value={context1}
                onChange={(e) => setContext1(e.target.value)}
                required
                placeholder="Enter the URL or description"
              />
            </div>
            <div className="input-group">
              <label>Upload Image:</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                required
              />
              {fileName && <p className="file-name">File Selected: {fileName}</p>}
            </div>
            <button type="submit" className="submit-btn">Submit</button>
          </form>
        </div>

        <div className="data-table">
          <h2>Reliable Authorities Data</h2>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Context</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item,index) => (
                <tr key={item.id}>
                  <td>{index+1}</td>
                  <td>
                    <a href={item.context1} target="_blank" rel="noopener noreferrer">
                      {item.context1}
                    </a>
                  </td>
                  <td>
                    <img
                      src={item.image}
                      alt="Reliable Authority"
                      className="image-thumbnail"
                    />
                  </td>
                  <td className="actions-column">
                    <button 
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                      disabled={isDeleting}
                    >
                      {isDeleting ? "Deleting..." : "Delete"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ReliableAuthorities;